<script setup>
import { onMounted, ref, watch } from "vue";
import Input from "@/Components/Settings/Input.vue";
import Select from "@/Components/Select.vue";
import { times } from "@/shared/utils";

const props = defineProps({
  title: String,
  start: String,
  end: String,
  start_2: String,
  end_2: String,
  hasBreak: Boolean,
  open: Boolean,
});

const open = ref(props.open);
const hasBreak = ref(props.hasBreak);

const emit = defineEmits([
  "update:start",
  "update:end",
  "update:start_2",
  "update:end_2",
  "update:open",
  "update:hasBreak",
]);

// watch(open, (value) => {
//   console.log(value);
//   if (value) {
//   } else {
//     emit("update:start_2", null);
//     emit("update:end_2", null);
//   }
// });
</script>

<template>
  <div class="flex items-center text-sm text-oteoText mt-3">
    <div :class="{ 'opacity-50': !open }" class="flex items-center w-32">
      <input
        @input="$emit('update:open', $event.target.checked)"
        v-model="open"
        type="checkbox"
      />
      <span class="ml-2 font-semibold text-lg"> {{ title }}</span>
    </div>
    <div class="mx-12" :class="{ 'opacity-50': !open }">
      von
      <Select
        @change="$emit('update:start', $event.target.value)"
        :disabled="!open"
        v-model="start"
        class="w-28 mx-3"
      >
        <option v-for="time in times" :key="time.value" :value="time.value">
          {{ time.text }}
        </option>
      </Select>
      bis
      <Select
        @change="$emit('update:end', $event.target.value)"
        :disabled="!open"
        v-model="end"
        class="w-28 mx-3"
      >
        <option
          v-for="time in times.filter((t) => t.value > (start || 0))"
          :key="time.value"
          :value="time.value"
        >
          {{ time.text }}
        </option>
      </Select>

      Uhr
    </div>
    <div class="" :class="{ 'opacity-50': !open || !hasBreak }">
      <input
        :disabled="!open"
        @input="$emit('update:hasBreak', $event.target.checked)"
        v-model="hasBreak"
        class="mr-2"
        type="checkbox"
      />

      und von
      <Select
        @change="$emit('update:start_2', $event.target.value)"
        :disabled="!open || !hasBreak"
        v-model="start_2"
        class="w-28 mx-3"
      >
        <option
          v-for="time in times.filter((t) => t.value > (end || 0))"
          :key="time.value"
          :value="time.value"
        >
          {{ time.text }}
        </option>
      </Select>

      bis
      <Select
        @change="$emit('update:end_2', $event.target.value)"
        :disabled="!open || !hasBreak"
        v-model="end_2"
        class="w-28 mx-3"
      >
        <option
          v-for="time in times.filter((t) => t.value > (start_2 || 0))"
          :key="time.value"
          :value="time.value"
        >
          {{ time.text }}
        </option>
      </Select>

      Uhr
    </div>
  </div>
</template>
